import React from "react";
import { motion } from "framer-motion";
import { Target, Eye } from "lucide-react";

export const MissionVision = () => {
  return (
    <section
      id="mision-vision"
      data-testid="mision-vision-section"
      className="bg-slate-50 py-24 lg:py-32"
    >
      <div className="container-page">
        <div className="max-w-3xl mb-14">
          <p className="text-xs uppercase tracking-[0.25em] text-[#055794] font-semibold mb-5">
            Propósito y dirección
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#022140] tracking-tight leading-[1.05] text-balance">
            Nuestra misión y visión, claras como nuestro compromiso.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {/* Mission - Dark */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative overflow-hidden rounded-3xl bg-[#022140] p-8 lg:p-12 text-white"
            data-testid="mission-card"
          >
            <div
              aria-hidden
              className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-[#055794]/40 blur-3xl"
            />
            <div className="relative">
              <div className="inline-flex items-center gap-3 mb-6">
                <span className="h-10 w-10 rounded-full bg-[#72B3E4]/20 border border-[#72B3E4]/40 flex items-center justify-center">
                  <Target size={18} className="text-[#72B3E4]" />
                </span>
                <span className="text-xs uppercase tracking-[0.25em] text-[#72B3E4] font-semibold">
                  Nuestra Misión
                </span>
              </div>
              <h3 className="font-heading text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                Impulsar el crecimiento de las organizaciones.
              </h3>
              <p className="text-[#72B3E4]/90 leading-relaxed text-[15px]">
                Impulsar el crecimiento de las organizaciones y la sociedad
                mediante la capacitación laboral inclusiva del sector privado y
                la investigación científica en ciencias sociales y humanidades.
                Nos dedicamos a diseñar estrategias innovadoras y programas de
                orientación social que permitan a personas desempleadas o con
                discapacidad integrarse productivamente al entorno empresarial,
                promoviendo la competitividad y el desarrollo sostenible.
              </p>
            </div>
          </motion.div>

          {/* Vision - Light Sky Blue */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="relative overflow-hidden rounded-3xl bg-[#72B3E4] p-8 lg:p-12 text-[#022140]"
            data-testid="vision-card"
          >
            <div
              aria-hidden
              className="absolute -right-20 -bottom-20 w-72 h-72 rounded-full bg-white/30 blur-3xl"
            />
            <div className="relative">
              <div className="inline-flex items-center gap-3 mb-6">
                <span className="h-10 w-10 rounded-full bg-[#022140]/10 border border-[#022140]/20 flex items-center justify-center">
                  <Eye size={18} className="text-[#022140]" />
                </span>
                <span className="text-xs uppercase tracking-[0.25em] text-[#022140] font-semibold">
                  Nuestra Visión
                </span>
              </div>
              <h3 className="font-heading text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                Líderes nacionales e internacionales.
              </h3>
              <p className="text-[#022140]/85 leading-relaxed text-[15px]">
                Ser reconocidos como la institución privada líder a nivel
                nacional e internacional en el desarrollo de la competitividad
                empresarial a través de la inclusión sociolaboral. Aspiramos a
                ser el referente obligado en investigación de ciencias sociales
                y humanidades, consolidando un modelo donde el desarrollo del
                talento vulnerable y la optimización de procesos corporativos
                extiendan un impacto positivo y sostenible en las
                organizaciones.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
